export enum ValidityEnum {
  Valid = 0,
  Invalid = 1,
  Missing = 2,
  Unknown = 255,
}
